/* eslint-disable max-len */
import { ActivationCodesProcessor, ExpiredLicensesProcessor } from 'common/repositoryProcessors/index';
import {
    LicensesRepository,
    AppIntegrationsRepository,
    ActivationCodesRepository,
    TransactionsRepository,
    PaymentTypesRepository,
} from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'Util', '$filter', '$state', 'ActivationCodeRestService', '$rootScope'];

class SubscriptionsTimelineController {

    constructor($scope, Util, $filter, $state, ActivationCodeRestService, $rootScope) {

        this.activationCodes = ActivationCodesProcessor.getSortedActivationCodes();
        this.licenses = LicensesRepository.getAll();
        this.expiredLicenses = ExpiredLicensesProcessor.getAll();
        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.Util = Util;
        this.$rootScope = $rootScope;

        const currentLanguage = CWCONFIG.language;
        const configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        let redirectSupportLanguage = '';

        if (configSupportLanguages.find(lang => lang === currentLanguage)) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';

            } else {

                redirectSupportLanguage = currentLanguage;

            }

        } else {

            redirectSupportLanguage = 'en-us';

        }
        this.$scope.cancellationPolicy = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        this.$scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);

        if (this.licenses.length > 0) {

            this.$scope.showLiceses = true;

            this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(this.licenses) : {};

        } else if (this.expiredLicenses.length > 0) {

            [this.$scope.firstExpiredLicense] = this.expiredLicenses;
            this.$scope.firstExpiredLicense.appIntegration = AppIntegrationsRepository.getById(this.Util.deepFind(this.$scope.firstExpiredLicense, 'relationships.app.data.id'));
            this.$scope.showExpiredLiceses = true;

        } else {

            this.$scope.showDefault = true;

        }

        this.transactions = TransactionsRepository.getAll();
        this.paymentTypes = PaymentTypesRepository.getAll();

        this.ActivationCodeRestService = ActivationCodeRestService;

        this.subjectActivationCodes = ActivationCodesProcessor.getObservable();
        this.activationCodesSubscriber = this.subjectActivationCodes
            .subscribe(
                data => this.onActivationCodesNext(data),
                () => { },
                () => { },
            );

        this.licensesRepository = LicensesRepository.getObservable();
        this.licensesSubscriber = this.licensesRepository
            .subscribe(
                data => this.onLicensesNext(data),
                () => { },
                () => { },
            );

        if (!sessionStorage.getItem('subscriptionWidgetNotification')) {

            sessionStorage.setItem('subscriptionWidgetNotification', true);

        }

        $scope.showNotification = sessionStorage.getItem('subscriptionWidgetNotification');

        $scope.goToRenewalSettings = () => {

            this.$rootScope.activeNavSection = 'renewal';

        };

        $scope.checkStaticOTC = (activationCode) => {

            let staticOTC = false;
            if (activationCode) {

                staticOTC = activationCode.attributes.subscription === 0 &&
                (
                    activationCode.attributes.subscription_type === 'yearly' ||
                    activationCode.attributes.subscription_type === 'prepaid'
                );

            }

            return staticOTC;

        };

        $scope.isBusinessProduct = (activationCode) => {

            let isBusinessProduct = false;

            if (activationCode) {

                const { businessProducts } = CWCONFIG.store || [];
                isBusinessProduct = !!(businessProducts.find(app => activationCode.attributes.app === app));

            }

            return isBusinessProduct;

        };

    }

    onActivationCodesNext() {

        const licenses = LicensesRepository.getAll();
        licenses.forEach((license) => {

            const appId = this.Util.deepFind(license, 'relationships.app.data.id');
            const activationCode = this.Util.deepFind(license, 'relationships.activation-code.data.id');
            license.appIntegration = AppIntegrationsRepository.getById(appId);

            if (activationCode) {

                license.activationCode = ActivationCodesRepository.getById(activationCode);

                if (license && license.activationCode) {

                    const expirationDate = this.Util.deepFind(license.activationCode, 'attributes.date_expire');

                    if (expirationDate) {

                        const todayFormatted = moment().format('L');
                        const expirationDateFormatted = moment(expirationDate).format('L');
                        license.activationCode.attributes.expiringToday = !!(todayFormatted === expirationDateFormatted);

                    }

                    license.activationCode.isVoucherPurchase = this.isVoucherPurchase(license.activationCode.id);
                    this.hasPaymentDetails(license.activationCode);

                }

            }

        });

        this.$scope.licenses = licenses;
        this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(licenses) : {};

    }

    onLicensesNext(data) {

        if (data.length > 0) {

            this.$scope.showLiceses = true;
            this.$scope.showDefault = false;

        } else if (this.expiredLicenses.length > 0) {

            this.$scope.showExpiredLiceses = true;

        } else {

            this.$scope.showDefault = true;

        }

        this.ActivationCodeRestService.getAllAsync().then((response) => {

            ActivationCodesRepository.replace(response.data.data);

        });

        data.forEach((license) => {

            const appId = this.Util.deepFind(license, 'relationships.app.data.id');
            const activationCode = this.Util.deepFind(license, 'relationships.activation-code.data.id');
            license.appIntegration = AppIntegrationsRepository.getById(appId);

            if (activationCode) {

                license.activationCode = ActivationCodesRepository.getById(activationCode);

            }

        });

        this.$scope.licenses = data;
        this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(data) : {};

    }

    subscriptionToggle(activationCode) {

        this.$state.go('root.dashboard.home.ltb', {
            ltb: 'confirm',
            resourceId: activationCode.id,
        }, {
            reload: false,
        });

    }

    onRenewalClick(licenseCode) {

        const appId = this.Util.deepFind(licenseCode, 'relationships.app.data.id');
        const isIframeProduct =
            CWCONFIG.subscriptions.iframeProducts.find(product => product === appId);

        if (isIframeProduct && licenseCode.attributes.cmp !== 'cobi2020avpro') {

            const licenseId = licenseCode.type === 'licenses' ? licenseCode.id : LicensesRepository.getLicenseBy(licenseCode.id).id;
            this.$scope.renewLink = '';

            this.$state.go('root.dashboard.home.ltb.renew', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'renew',
                licenseId,
            }, {
                reload: false,
            });

        } else {

            this.$scope.renewLink = `${this.Util.deepFind(licenseCode, 'attributes.renewal_link')}&x-a-source=cw`;

        }

        this.$scope.cardDeletedRenewLink = isIframeProduct ? '' : `${this.Util.deepFind(licenseCode, 'attributes.renewal_link')}&x-a-source=cw`;

    }

    sendSubscriptionsMixpanel(buttonLabel, licenseName, currentLicenseStatus) {

        const cmp = this.Util.deepFind(this.$scope.firstExpiringLicense, 'attributes.cmp');
        let isCobiLicense = false;

        if (cmp === 'cobi2020avpro') {

            isCobiLicense = true;

        }

        const mixpanelPayload = {
            Label: 'Subscriptions',
            'Button label': buttonLabel,
            'License Name': licenseName || '',
            'COBI License': isCobiLicense,
            'Current License Status': currentLicenseStatus || '',
            'Notification overlay': this.$scope.showNotification.toString(),
        };

        Mixpanel.send('ConnectWeb Home Click', mixpanelPayload);

    }

    setScrollToExpiredSubscriptions() {

        this.$rootScope.scrollToExpiredSubscriptions = true;

    }

    /* check if this was purchased by family and friend voucher so we will
        hide autorenew toogle and enable subscription button */
    isVoucherPurchase(activateCode) {

        const getTransactions = TransactionsRepository.getAll();
        const transactionWithVoucher =
            getTransactions.find(transaction =>
                transaction.attributes.activation_code === activateCode);

        if (transactionWithVoucher && transactionWithVoucher.attributes) {

            return transactionWithVoucher.attributes.payment_type === 'Voucher';

        }

        return false;

    }

    hasPaymentDetails(license) {

        const activationCodePurchaseDate = this.transactions.find(transaction =>
            transaction.attributes.activation_code === license.id);

        // Check if the payment type associated with the current activation code was removed
        // Get transaction id associated with the current activation code
        const paymentTransactionId = this.Util.deepFind(activationCodePurchaseDate, 'attributes.payment_transaction_id');

        // Get payment type details based on the transaction id
        const paymentTypeDetails =
            this.paymentTypes.find(payment => payment.id === paymentTransactionId);

        // If the card was removed, so we need to disable the auto-renewal toggle
        if (this.Util.isPaymentCardDeleted(paymentTypeDetails)) {

            license.removedPaymentOption = true;

        }

    }

    /* Check if there are licenses with subscription off and return the first one */
    checkUnsubscribedLicenses(licenses) {

        let firstUnsubscribedLicense = {};
        const unsubscribedLicenses = licenses.filter(license => license.attributes.subscription === 0);

        if (unsubscribedLicenses.length > 0) {

            const latestDate = unsubscribedLicenses.map(license => license.attributes.expiration_date).sort()[0];
            firstUnsubscribedLicense = unsubscribedLicenses.find(license => license.attributes.expiration_date === latestDate);

            const appIntegration = AppIntegrationsRepository.getById(this.Util.deepFind(firstUnsubscribedLicense, 'relationships.app.data.id'));
            firstUnsubscribedLicense.productName = appIntegration.attributes.resource.oeName;

        }

        // Hide subscriptions card from homepage on certain activation code properties (moved from html)
        if (firstUnsubscribedLicense.productName) {

            // check if it's a static otc
            const staticOTC = firstUnsubscribedLicense.attributes.subscription_type === 'yearly' ||
                firstUnsubscribedLicense.attributes.subscription_type === 'prepaid';

            // check if it's a business product
            const { businessProducts } = CWCONFIG.store || [];
            const appId = this.Util.deepFind(firstUnsubscribedLicense, 'relationships.app.data.id');
            const isBusinessProduct = !!(businessProducts.find(app => appId === app));

            if (staticOTC || isBusinessProduct ||
                firstUnsubscribedLicense.attributes.has_partner_id ||
                firstUnsubscribedLicense.attributes.expiringToday) {

                angular.element('.subscriptions-card').css('display', 'none');

            }

            if (firstUnsubscribedLicense.activationCode &&
                (firstUnsubscribedLicense.activationCode.removedPaymentOption ||
                firstUnsubscribedLicense.activationCode.isVoucherPurchase)) {

                angular.element('.subscriptions-card').css('display', 'none');

            }

        }

        return firstUnsubscribedLicense;

    }

}


class SubscriptionsTimelineDirective {

    constructor() {

        this.template = require('./subscriptions-timeline.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $scope, Util, $filter, $state,
            ActivationCodeRestService, $rootScope,
        ) =>
            new SubscriptionsTimelineController(
                $scope, Util, $filter, $state,
                ActivationCodeRestService, $rootScope,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'SubscriptionsTimelineCtrl';

    }

}

_directiveDependencies.push(() => new SubscriptionsTimelineDirective());


angular.module('directives')
    .directive('subscriptionsTimeline', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/subscriptions-timeline/subscriptions-timeline.js